import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NonNullableFormBuilder, FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ContactUsForm } from '../interfaces/forms';
import { NgClass } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';

@Component({
    selector: 'app-contactus',
    templateUrl: './contactus.component.html',
    styleUrls: ['./contactus.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, FooterComponent, MrpScrolltopComponent]
})
export class ContactUsComponent implements OnInit {

  contactForm!: FormGroup<{
    name: FormControl<string>;
    subject: FormControl<string>;
    question: FormControl<string>;
    replyEmail: FormControl<string>;
  }>;
  statusMSG = 'Submit';
  submitted = false;
  submissionSuccess = false;
  submissionError = false;
  loading = false;
  backendUrl = 'api/support/question.php'; // IMPORTANT: Replace with your actual PHP backend URL

  constructor(private fb: NonNullableFormBuilder, private http: HttpClient, private router: Router, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: this.fb.control('', [Validators.required]),
      subject: this.fb.control('', [Validators.required]),
      question: this.fb.control('', [Validators.required]),
      replyEmail: this.fb.control('', [Validators.required, Validators.email])
    });
  }

  get f() { return this.contactForm.controls; }

  // Function to strip non-plain characters from a string
  // Keeps alphanumeric characters, spaces, periods, and commas.
  stripToPlainCharacters(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    // Regex: ^ (start of string), $ (end of string)
    // [a-zA-Z0-9 .,] matches alphanumeric, space, period, or comma
    // g (global) matches all occurrences, not just the first
    // '' replaces matched characters with an empty string (effectively removes them)
    return value.replace(/[^a-zA-Z0-9 .,]/g, '');
  }

  onSubmit(): void {
    this.submitted = true;
    this.submissionSuccess = false; // Reset success message
    this.submissionError = false;   // Reset error message

    this.loading = true; // Start loading state
    this.statusMSG = 'Sending...'; // Change button text to indicate submission
    // Mark all controls as touched to display validation errors immediately
    this.contactForm.markAllAsTouched();

    // Stop here if form is invalid
    if (this.contactForm.invalid) {
      //console.log('Form is invalid. Please check the fields.');
      // Reset loading and UI state since submission won't proceed
      this.loading = false;
      this.statusMSG = 'Submit';
      this.submitted = false;
      return;
    }

    // Client-side stripping before sending
    const formValue = this.contactForm.getRawValue();
    const rawSubject = formValue.subject;
    const rawQuestion = formValue.question;
    const rawName = formValue.name;

    const strippedSubject = this.stripToPlainCharacters(rawSubject);
    const strippedQuestion = this.stripToPlainCharacters(rawQuestion);
    const strippedName = this.stripToPlainCharacters(rawName);

    const formData: ContactUsForm = {
      name: strippedName,
      subject: strippedSubject,
      question: strippedQuestion,
      replyEmail: formValue.replyEmail
    };

    // Send data to PHP backend
    this.http.post(this.backendUrl, formData).subscribe({
      next: (response: any) => {
        this.loading = false;
        //console.log('Backend response:', response);
        if (response && response.success) {
          this.submissionSuccess = true;
          this.contactForm.reset(); // Reset form after successful submission
          this.submitted = false;   // Reset submitted flag
        } else {
          this.submissionError = true;
          this.loading = false;
          console.error('Submission failed:', response.message || 'Unknown error');
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.submissionError = true;
        this.loading = false;
        console.error('HTTP error during submission:', error);
        this.cdr.markForCheck();
      }
    });
  }

  goToHome(): void {
    this.router.navigate(['home']);
    this.submissionSuccess = false; // Hide success message
    this.submissionError = false;   // Hide error message
  }

}
